import type { FileUploaderProps } from 'src/components/FileUploader/FileUploader';

// FIXME (FED-4073) intl all these strings
export function getHumanReadableStringOfAcceptedMimeTypes(
  acceptedMimeTypes: NonNullable<FileUploaderProps['acceptedMimeTypes']>
): string {
  return `${Object.values(acceptedMimeTypes)
    .map((values) =>
      values.map((value) => value.replace(/^\./, '').toUpperCase())
    )
    .join(', ')}`;
}

export default getHumanReadableStringOfAcceptedMimeTypes;
